import { useQuery } from "@tanstack/react-query";
import { Buton } from "@koclukpanel/ui";
import { yedekUyariBandi } from "./api";

/**
 * ANA EKRAN YEDEK BANDI — F-YED-22
 *
 * ================================================================
 * BANT YALNIZCA ELINDEN BIR SEY GELENE GOSTERILIYOR
 * ================================================================
 * Cagiran, kullanicida `sistem.yedek.yonet` olup olmadigina bakip
 * bileseni ciziyor; uc de ayni izni istiyor. Uzmana "tatbikat
 * gecikti" demek, yapamayacagi bir is icin onu kaygilandirmak olur.
 *
 * ================================================================
 * BANT NADIR OLMALI
 * ================================================================
 * Esik 45 gun ve konsolun 31 gununden AYRI. Ayni esik kullanilsaydi
 * bant her ay bir kez cikip kaybolur, bir sure sonra kimse okumazdi.
 */
export function YedekBandi({ onGit }: { onGit: () => void }) {
  const { data } = useQuery({
    queryKey: ["yedek-uyari-bandi"],
    queryFn: yedekUyariBandi,
    // Ana ekranda her acilista sorulmasin: bant gunler mertebesinde
    // degisen bir sey.
    staleTime: 5 * 60_000,
  });

  // Veri yoksa ya da bant gerekmiyorsa HICBIR SEY cizilmiyor —
  // "yükleniyor" bile: bos bir seritin yer tutmasi, ana ekrani her
  // acilista titretirdi.
  if (!data?.goster) return null;

  return (
    <div
      role="alert"
      className="rounded-kart shadow-kart border-hata-500/30 bg-hata-500/10 mb-4 flex flex-wrap items-center justify-between gap-3 border p-3"
    >
      <p className="text-notr-800 text-sm">
        <strong>Yedekleme:</strong> {data.mesaj}
      </p>
      <Buton gorunum="ikincil" onClick={onGit}>
        Yedekleme ekranına git
      </Buton>
    </div>
  );
}
